import { and } from '@lumapps/utils/function/predicate/and';
import { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchNode, matchAttribute } from '@lumapps/wrex/serialization/html/fromHTML/utils';

import { CLASSNAME as COLUMN_CLASSNAME } from '../../../components/blocks/Column';
import { CLASSNAME as COLUMNS_CLASSNAME } from '../../../components/blocks/Columns';
import { COLUMN, COLUMNS } from '../../../constants';
import { createColumn } from '../../../utils/createColumn';
import { createColumns } from '../../../utils/createColumns';

type ElementTypes = typeof COLUMNS | typeof COLUMN;

/**
 * Element convert options.
 *
 * Warning: the order of these options does matter!
 */
export const ELEMENTS: { [Element in ElementTypes]: HTMLElementConvertOption<Element> } = {
    columns: {
        test: and(matchNode({ tagName: 'div' }), matchAttribute('className', new RegExp(COLUMNS_CLASSNAME))),
        type: COLUMNS,
        transform: (_, children) => {
            return createColumns({}, children);
        },
    },
    column: {
        test: and(matchNode({ tagName: 'div' }), matchAttribute('className', new RegExp(COLUMN_CLASSNAME))),
        testParent: and(matchNode({ tagName: 'div' }), matchAttribute('className', new RegExp(COLUMNS_CLASSNAME))),
        type: COLUMN,
        transform: (_, children) => {
            return createColumn({}, children);
        },
    },
};
